export default __webpack_public_path__ + "static/media/mana16.d60e8fdc.svg";